import { useMemo, useRef, useSyncExternalStore } from 'react';
import { LlmStreamController, type LlmStreamState } from './LlmStreamController';
import { shallowEqual } from '@ayocore/platform/client/utils/shallowEqual';

/**
 * Хук подписки на LlmStreamController.
 * Поддерживает селектор для минимизации ререндеров.
 */
export function useLlmStreamController(): LlmStreamState;
export function useLlmStreamController<S>(selector: (s: LlmStreamState) => S): S;
export function useLlmStreamController<S = LlmStreamState>(
  selector?: (s: LlmStreamState) => S
): S | LlmStreamState {
  const ctrl = LlmStreamController.getInstance();
  const state = useSyncExternalStore(ctrl.subscribe, ctrl.getSnapshot, ctrl.getSnapshot);

  if (!selector) return state;

  const selectedRef = useRef<S | undefined>(undefined);
  return useMemo(() => {
    const selected = selector(state);
    if (selectedRef.current !== undefined) {
      if (shallowEqual(selectedRef.current, selected)) {
        return selectedRef.current as S;
      }
    }
    selectedRef.current = selected;
    return selected;
  }, [state, selector]);
}
